var result = require("!!../../../../node_modules/html-loader/index.js?interpolate!./config_section.html")
var H = require("hogan.js");
module.exports = function() {
var T = H.compile(result, {});
return T; }();


//////////////////
// WEBPACK FOOTER
// ./node_modules/mustache-loader?noShortcut!./node_modules/html-loader?interpolate!./src/components/guideline/templates/config_section.html
// module id = 125
// module chunks = 0